const LinkedInCircleIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="38" height="38" rx="19" fill="currentColor" />
        <g clip-path="url(#clip0_522_6481)">
          <path
            d="M25.992 25.9928V20.8704C25.992 18.3528 25.4501 16.4297 22.5129 16.4297C21.0968 16.4297 20.1527 17.1989 19.7681 17.9332H19.7332V16.657H16.9534V25.9928H19.8555V21.3599C19.8555 20.1361 20.0828 18.9647 21.5863 18.9647C23.0724 18.9647 23.0899 20.3459 23.0899 21.4298V25.9754H25.992V25.9928Z"
            fill="white"
          />
          <path
            d="M12.2336 16.6572H15.1358V25.9931H12.2336V16.6572Z"
            fill="white"
          />
          <path
            d="M13.6845 12.0059C12.7579 12.0059 12.0061 12.7576 12.0061 13.6842C12.0061 14.6108 12.7579 15.3801 13.6845 15.3801C14.6111 15.3801 15.3628 14.6108 15.3628 13.6842C15.3628 12.7576 14.6111 12.0059 13.6845 12.0059Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_522_6481">
            <rect x="12" y="12" width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default LinkedInCircleIcon;
